import { useWeeklyLimit } from "@/api/weekly-limit-query";

export default defineComponent({
	name: "AlertConditionDescription",
	props: {
		weeklyLimit: [String, null],
	},
	setup(props) {
		const weeklyLimitId = computed(() => props.weeklyLimit || "");

		const { data: weeklyLimit } = useWeeklyLimit(weeklyLimitId);
		function generateWeeklyLimitName() {
			if (!weeklyLimitId.value) {
				return "";
			}
			return weeklyLimit.value?.name || "";
		}

		const description = computed(() => {
			return generateWeeklyLimitName() || "-";
		});
		return () => <div>{description.value}</div>;
	},
});
